var map = {
	"./accordion-arrow.svg": 608,
	"./arrow.svg": 609,
	"./bigcommerce-logo.svg": 610,
	"./magento1-logo.svg": 611,
	"./magento2-logo.svg": 612,
	"./opencart-logo.svg": 613,
	"./prestashop-logo.svg": 614,
	"./shopify-logo.svg": 615,
	"./shopware-logo.svg": 616,
	"./trustpilot-logo.svg": 617,
	"./woocommerce-logo.svg": 618
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 607;


//////////////////
// WEBPACK FOOTER
// ./src/Assets/images ^\.\/.*\.svg$
// module id = 607
// module chunks = 0